"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGamePlugin = exports.GameType = void 0;
var GameType;
(function (GameType) {
    GameType["SLOT_GAME"] = "slotGame";
    GameType["INSTANT_GAME"] = "instantGame";
})(GameType = exports.GameType || (exports.GameType = {}));
function isGamePlugin(value) {
    return value.getPaytable !== undefined;
}
exports.isGamePlugin = isGamePlugin;
//# sourceMappingURL=GamePlugin.js.map